import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { ContentPackages } from './content-packages.dto';

export class ContentPackagesDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return ContentPackages.fromDto(dto) as any;
  }
}
